import React from "react";

function PrintIcon() {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.4169 4.5H12.5V2.5C12.5 2.36739 12.4473 2.24021 12.3536 2.14645C12.2598 2.05268 12.1326 2 12 2H4C3.86739 2 3.74021 2.05268 3.64645 2.14645C3.55268 2.24021 3.5 2.36739 3.5 2.5V4.5H2.58313C1.71 4.5 1 5.17313 1 6V11C1 11.1326 1.05268 11.2598 1.14645 11.3536C1.24021 11.4473 1.36739 11.5 1.5 11.5H3.5V13.5C3.5 13.6326 3.55268 13.7598 3.64645 13.8536C3.74021 13.9473 3.86739 14 4 14H12C12.1326 14 12.2598 13.9473 12.3536 13.8536C12.4473 13.7598 12.5 13.6326 12.5 13.5V11.5H14.5C14.6326 11.5 14.7598 11.4473 14.8536 11.3536C14.9473 11.2598 15 11.1326 15 11V6C15 5.17313 14.29 4.5 13.4169 4.5ZM4.5 3H11.5V4.5H4.5V3ZM11.5 13H4.5V10H11.5V13ZM14 10.5H12.5V9.5C12.5 9.36739 12.4473 9.24021 12.3536 9.14645C12.2598 9.05268 12.1326 9 12 9H4C3.86739 9 3.74021 9.05268 3.64645 9.14645C3.55268 9.24021 3.5 9.36739 3.5 9.5V10.5H2V6C2 5.72438 2.26188 5.5 2.58313 5.5H13.4169C13.7381 5.5 14 5.72438 14 6V10.5ZM12.5 7.25C12.5 7.39834 12.456 7.54334 12.3736 7.66668C12.2912 7.79001 12.1741 7.88614 12.037 7.94291C11.9 7.99968 11.7492 8.01453 11.6037 7.98559C11.4582 7.95665 11.3246 7.88522 11.2197 7.78033C11.1148 7.67544 11.0434 7.5418 11.0144 7.39632C10.9855 7.25083 11.0003 7.10003 11.0571 6.96299C11.1139 6.82594 11.21 6.70881 11.3333 6.6264C11.4567 6.54399 11.6017 6.5 11.75 6.5C11.9489 6.5 12.1397 6.57902 12.2803 6.71967C12.421 6.86032 12.5 7.05109 12.5 7.25Z"
          fill="#2F80ED"
        />
      </svg>
    </>
  );
}

export default PrintIcon;
